import React, {
	useEffect, memo
}from "react"
import "antd/lib/switch/style/index.css"
import {
	Row, Col, Tag, Tooltip
}from "antd"
import "./style.css"
import {
	appealsActions
}from "../store/actions"

import {
	appealUserActions
}from "../../AppealUser/store/actions"
import {
	useDispatch, useSelector
}from "react-redux"
import moment from "moment"
import ConvertDBAddressToString from "../../../helpers/convertDBAddressToString"

import SignedIcon from "../../../../public/signedIcon.png"
import AppealFiles from "../AppealFiles"
import AdditionalOrderMessage from "./Components/additionalOrderMessage"
import ResolutionResult from "./Components/resolutionResult"
import AppealResult from "./Components/appealResult"
import RecallByRegistratorInfo from "../AppealRecallByRegistrator/recallByRegistratorInfo"
import HighlightSubstring from "../../../components/HighlightSubstring"
import i18nlocal from "./localization"

const ColAddress = (address, isRu) => (<Col>
	<span>
		{ isRu
			? "Зарегистрированного по адресу: "
			: "Зарэгістраванага па адрасе: " }
		{ address }
	</span>
</Col>)

const ColPhone = (phone, isRu) => (phone ? <Col>
	<span>
		{ isRu ? "Контактный телефон: " : "Кантактны тэлефон: " }
		{ phone }
	</span>
</Col> : null)

const ColEmail = (email, isRu) => (<Col>
	<span>
		{ isRu ? "Электронный адрес: " : "Электронны адрас: " }
		{ email }
	</span>
</Col>)

const AppealInfo = memo((props) => {
	const {
		reOrg,
		redirects,
		reOrgAppeal,
		appeal,
		pendingAppealData,
		appealId,
		reviewResult,
		isRu,
		i18n,
		raId,
		appealSignPerson,
		reOrgAppealSignPerson,
		isRecalled
	} = props
	const dispatch = useDispatch()
	const { user } = useSelector((state) => state.userReducer)
	const { answerFiles, appealFiles, downloadAppealFileLoading } = useSelector((state) => state.appealsReducer)
	const { userAddress, reOrgInfo } = useSelector((state) => state.appealUserReducer)
	const reFormTypeList = useSelector((state) => state.appealsReducer.reFormTypeList)
	const minReOrgAppealsInfo = useSelector((state) => state.appealsReducer.minReOrgAppealsInfo)
	const queryParams = new URLSearchParams(window.location.search);
    const context = queryParams.get('context');

	useEffect(() => {
		dispatch(appealUserActions.getAppealUserAddress({
			AppealId : appeal.id,
			UserId   : appeal.creatorId
		}))
		return () => {
			dispatch(appealUserActions.clearAppealUserAddress())
		}
	}, [])
	useEffect(() => {
		if (!pendingAppealData){
			dispatch(appealsActions.GetMinReOrgAppealInfoByAppealId({
				AppealId: appealId
			}))
			reOrgAppeal &&
				dispatch(appealsActions.GetRepeatAppeals({
					ReOrgAppealId: reOrgAppeal.id
				}))
		}
		return () => {
			dispatch(appealsActions.ClearMinReOrgAppealInfoByAppealId())
			dispatch(appealsActions.ClearRepeatAppeals())
		}
	}, [])

	useEffect(() => {
		if(reOrgAppeal){
			dispatch(appealsActions.GetAppealFilesByAppealId({
				AppealId: reOrgAppeal.appeal.id
			}))
			dispatch(appealsActions.GetAnswerFilesByAppealId({
				ReOrgAppealId: reOrgAppeal.id
			}))
		}
		return () => {
			dispatch(appealsActions.ClearAnswerFilesByAppealId())
			dispatch(appealsActions.ClearAppealFilesByAppealId())
		}
	}, [reOrgAppeal])

	function downloadAppealFile(item){
		dispatch(appealsActions.DownloadAppealFile({
			FileId: item.id
		}, item.fileName, item.fileExtension))
	}

	function downloadAllAppealFiles(reOrgAppealId, fileName){
		dispatch(appealsActions.DownloadAllAppealFiles({
			reOrgAppealId: reOrgAppealId
		}, fileName))
	}

	function downloadAppealAnswerFile({id, fileName, fileExtension}){
		if(!downloadAppealFileLoading){
			dispatch(appealsActions.DownloadAppealAnswerFile({
				FileId: id
			}, fileName, fileExtension))
		}
	}

	const reOrgName = reOrg
		? isRu
			? reOrg.fullName
			: reOrg.fullNameBel
				? reOrg.fullNameBel
				: reOrg.fullName
		: null

	const isColective =
		appeal.reAppealType?.name == "Коллективное"
			? appeal.isPrivate == true
				? i18n.closeCollectAppeal[isRu]
				: appeal.isFormed === true
					? i18n.formedCollectAppeal[isRu]
					: i18n.openCollectAppeal[isRu]
			: null
	const filingForm =
		reFormTypeList &&
		reFormTypeList.find((x) => x.id === reOrgAppeal && reOrgAppeal.appeal.reFormTypeId)
		
	return (
		<>
			{ appeal ? (
				<div className="">
					<Row>
						<Col span={ 6 }>
							{ reOrgAppeal && (
								<div className="status-appeal">
									{ reOrgAppeal && reOrgAppeal.appeal && reOrgAppeal.appeal.regNumber ? (
										<span>
											{ `№${ reOrgAppeal.appeal.regNumber }` }
										</span>
									) : null }
									<Tag className={`statusCode${reOrgAppeal?.status.code}`}>
										{ reOrgAppeal && reOrgAppeal.status.code == "8"
											? isRu
												? "Зарегистрировано"
												: "Зарэгістравана"
											: reOrgAppeal && reOrgAppeal.status.code == "14"
												? isRu
													? "Исполнено"
													: "Выканана"
												: reOrgAppeal && reOrgAppeal.appeal.creatorId ==  user.id && reOrgAppeal.status.code == "20"
													? isRu 
													  ? "Дан ответ" 
												      : "Дадзены адказ"
													: `${ isRu
														? reOrgAppeal && reOrgAppeal.status.name
														: reOrgAppeal && reOrgAppeal.status.nameBel
													}` }
									</Tag>
										{ ["13","14"].includes(reOrgAppeal?.status.code) && reOrgAppeal?.reOrgAppealsAnswerForms 
										?
											<>
													
												{ user.reOrg?.id == reOrgAppeal?.reOrg?.id && reOrgAppeal.completeStatus &&
													<Tag className={`completeStatusCode${reOrgAppeal?.completeStatus?.id}`}>
														{isRu ? reOrgAppeal.completeStatus?.name : reOrgAppeal.completeStatus?.nameBel}
													</Tag>
												}
												<span className="response-forms">
													{
														<span>{`${i18n.responseForms[isRu]}:`}</span>
													}
													{	
														reOrgAppeal.reOrgAppealsAnswerForms.map((value) => {
														return isRu ? <div>{value.reAnswerForm.name}</div> : <div>{value.reAnswerForm.nameBel}</div>
													})}
												</span>
											</>
										:	
											null 
										}
								</div>
							) }
						</Col>
						<Col
							offset={ 6 }
							span={ 12 }
						>
							<Row className="info-appeal">
								<Col>
									{ /* <span>
										{ isRu ? reOrgAppeal && reOrgAppeal.reOrg.fullName : reOrgAppeal && reOrgAppeal.reOrg.fullNameBel }
									</span> */ }
									{ isRu ? "Обращение подано: " : "Зварот пададзены: " }

									{ !pendingAppealData
										? minReOrgAppealsInfo
											? minReOrgAppealsInfo.map((item, index) => {
												if (isRu){
													return (
														<div>
															{item.isRedirected ?
															<span>
																{"Перенаправлено в:"}
															</span> : null }
															<span key={ index }>
																{ item.reOrgNameShort
																	? item.reOrgNameShort
																	: item.reOrgName 
																}
															</span>
														</div>
													)
												}
												return (
													<div>
														{item.isRedirected ?
															<span>
																{"Перанакіравана ў:"}
															</span> : null }
														<span key={ index }>
															{ item.reOrgNameShortBel
																? item.reOrgNameShortBel
																: item.reOrgNameBel
																	? item.reOrgNameBel
																	: item.reOrgNameShort
																		? item.reOrgNameShort
																		: item.reOrgName }
														</span>
													</div>
												)
											})
											: null
										: pendingAppealData.map((item, index) => {
											return (
												<span>
													{ isRu
														? item.org.shortName
															? item.org.shortName
															: item.org.fullName
														: item.org.shortNameBel
															? item.org.shortNameBel
															: item.org.fullNameBel
																? item.org.fullNameBel
																: item.org.shortName
																	? item.org.shortName
																	: item.org.fullName }
												</span>
											)
										}) }
								</Col>
								{ appeal.personalExecutor ? (
									<Col>
										<span>
											{ appeal.personalExecutor }
										</span>
									</Col>
								) : null }
								{ appeal.reOrgComplaint ? (
									<Col>
										<span
										style={ {
												display      : "block"
											} }
										>
											{i18nlocal.complaint[isRu]}
										</span>
										<span
											style={ {
												display      : "block",
												marginBottom : "10px"
											} }
										>
											{ isRu
												? appeal.reOrgComplaint.fullName
												: appeal.reOrgComplaint.fullNameBel
													? appeal.reOrgComplaint.fullNameBel
													: appeal.reOrgComplaint.fullName }
										</span>
										{ appeal.complaintPerson ? (
											<span style={ { display: "block" } }>
												{ appeal.complaintPerson }
											</span>
										) : null }
									</Col>
								) : null }
								{ /* {reOrgAppeal && reOrgAppeal.executor && (
									<Col>
										<span>
											{reOrgAppeal && reOrgAppeal.executor
												? reOrgAppeal.executor.middleName != null
													? `${reOrgAppeal &&
													reOrgAppeal.executor.lastName} ${reOrgAppeal &&
													reOrgAppeal.executor.firstName} ${reOrgAppeal &&
													reOrgAppeal.executor.middleName}`
													: `${reOrgAppeal &&
													reOrgAppeal.executor.lastName} ${reOrgAppeal &&
													reOrgAppeal.executor.firstName}`
												: isRu
													? "Исполнитель отсутствует"
													: "Выканаўца адсутнічае"}
										</span>
									</Col>
								)} */ }
								{ (reOrgAppeal && appeal.reAppealType?.code != '3') && (
									<Col>
										<span>
											{ isRu ? "Заявитель: " : "Заяўнік: " }

											{ reOrgAppeal && reOrgAppeal.appeal.applicantType
												? reOrgAppeal.appeal.orgCreator
													? isRu
														? reOrgAppeal.appeal.orgCreator.fullName
														: reOrgAppeal.appeal.orgCreator.fullNameBel
															? reOrgAppeal.appeal.orgCreator.fullNameBel
															: reOrgAppeal.appeal.orgCreator.fullName
													: ""
												: reOrgAppeal.appeal &&
												`${ reOrgAppeal.appeal.applicantLastName ?? "" } 
					  		${ reOrgAppeal.appeal.applicantFirstName ?? "" }
							${ reOrgAppeal.appeal.applicantMiddleName ?? "" }` }
										</span>
									</Col>
								) }
								{ filingForm && (
									<Col>
										<span>
											{ isRu
												? `Обращение подано: ${ filingForm && filingForm.name }`
												: `Зварот пададзен: ${ filingForm &&
												filingForm.nameBel }` }
										</span>
									</Col>
								) }
								{ appeal.reAppealType?.code != '3' ? (
									reOrgAppeal && reOrgAppeal.appeal.applicantType
										? (reOrgInfo && reOrgInfo.orgAddress) ||
										(appeal && appeal.address)
											? ColAddress(ConvertDBAddressToString(reOrgInfo && reOrgInfo.orgAddress
												? reOrgInfo.orgAddress
												: appeal && appeal.address
													? appeal.address
													: null, isRu), isRu)
											: null
										: !userAddress
											? ColAddress(appeal.use, isRu)
											: ColAddress(ConvertDBAddressToString(userAddress, isRu), isRu)
								): null }
								{ appeal.reAppealType?.code != '3' ? (reOrgAppeal && reOrgAppeal.appeal.applicantType
									? ColPhone(reOrgInfo.orgPhone ?? appeal.applicantPhone, isRu)
									: appeal.applicantPhone
										? ColPhone(appeal.applicantPhone, isRu)
										: null
								): null }

								{ (appeal.reAppealType?.code != '3' && appeal.email) ? (ColEmail(appeal.email, isRu)): null }

							</Row>
						</Col>
					</Row>
					<Row className="body-info-appeal">
						<Col className="header-body-info-appeal">
							<span>
								{ appeal.reAppealViewType
									? isRu
										? appeal.reAppealViewType.name
										: appeal.reAppealViewType.nameBel
									: null }

								{ ` (${ isRu
									? appeal.reAppealType?.name
									: appeal.reAppealType?.nameBel
								}${ reOrgAppeal && isColective && reOrgAppeal.moreThan30Applicants ? `: ${ i18n.moreThan30Applicants[isRu] }` : "" }) ` }
								{ reOrgAppeal && reOrgAppeal?.orgRegNumber ? (
									<span>
										№
										{ reOrgAppeal && reOrgAppeal.orgRegNumber }
									</span>
								) : null }
								{appeal.signerInfo && reOrgAppeal.appeal.creatorId != user.id &&
								<Tooltip 
									title={i18n.signer[isRu].format(appeal.signerInfo)}
									overlayInnerStyle={{ whiteSpace: 'pre-line' }}	
									className="signed_icon"	
								>
									<img src={SignedIcon} className="signed_icon_for_message"/>
								</Tooltip>}
							</span>
							{ /* <span>
								{ reOrgAppeal.isRepetition ?
									`${ i18n.IsRepetitionTitle[isRu] } ${ reOrgAppeal.previousAppealId ?
										(<Link
			 											target="_blank"
			 											to={ `/appeal/${ reOrgAppeal.previousAppealId }` }
										>
			 											{ `${ i18n.appeal[isRu]
			 											} №${
			 												reOrgAppeal.previousAppealRegNum }` }
										</Link>)
										: null
													 }`
													 : null }
							</span> */ }
						</Col>
						<Col
							className="text-body-info-appeal"
						>
							<HighlightSubstring 
								text={`\t${ appeal.content }`.replace(/\n/g, `\n\t`)} 
								substring={context ?? ""} 
							/>
						</Col>
						<Col className="files-body-info-appeal">
							<AppealFiles
								isRu={ isRu }
								fileList={appealFiles}
								downloadMethod ={downloadAppealFile}
								downloadAllMethod ={downloadAllAppealFiles}
								reOrgAppeal = {reOrgAppeal}
							/>
						</Col>
					</Row>
					<Row className="footer-info-appeal">
						<Col span={ 12 }>
							<span>
								{ isRu ? "Дата подачи" : "Дата падачы" }
:
								{ ' ' }
								{ moment.parseZone(reOrgAppeal.creationDate).format("DD.MM.YYYY HH:mm") }
							</span>
						</Col>
						<Col span={ 12 }>
							<span>
							{ reOrgAppeal && reOrgAppeal.appeal.applicantType
												? reOrgAppeal.appeal.orgCreator
													? isRu
														? reOrgAppeal.appeal.orgCreator.fullName
														: reOrgAppeal.appeal.orgCreator.fullNameBel
															? reOrgAppeal.appeal.orgCreator.fullNameBel
															: reOrgAppeal.appeal.orgCreator.fullName
													: ""
												: reOrgAppeal.appeal &&
												`${ reOrgAppeal.appeal.applicantLastName ?? "" } 
					  		${ reOrgAppeal.appeal.applicantFirstName ?? "" }
							${ reOrgAppeal.appeal.applicantMiddleName ?? "" }` }
							</span>
						</Col>
						{ reOrgAppeal && (
							<Col span={ 12 }>
								<span>
									{ reOrgAppeal?.registerDate
										? `${ isRu ? "Дата регистрации" : "Дата рэгістрацыі" }: ${ moment.parseZone(reOrgAppeal && reOrgAppeal.registerDate).format("DD.MM.YYYY") }`
										: null }
								</span>
							</Col>
						) }
						{ reOrgAppeal && (
							<Col span={ 12 }>
								{ reOrgAppeal?.executor ? (
									<>
										<span
											style={ {
												display      : "block",
												marginBottom : "5px"
											} }
										>
											{ reOrgName }
										</span>

										{ /* <span>
											{`${reOrgAppeal &&
												reOrgAppeal.executor.lastName} ${reOrgAppeal &&
												reOrgAppeal.executor.firstName} ${reOrgAppeal && reOrgAppeal.executor.middleName
													? reOrgAppeal && reOrgAppeal.executor.middleName
													: ""
												} ` +
												`(${isRu
													? reOrgAppeal && reOrgAppeal.executor.position
													: reOrgAppeal && reOrgAppeal.executor.positionBel
												})`}
										</span> */ }
									</>
								) : null }
							</Col>
						) }
					</Row>
					<div className="result-appeal-list">
					{
						reOrgAppeal?.resolutionResultsList?.length > 0 &&
							reOrgAppeal?.resolutionResultsList?.map((value, number) => { return (
								<ResolutionResult
									isRu={isRu}
									resolutionResult={value}
									showSignerInfo={reOrgAppeal.appeal.creatorId != user.id}
									key={number}
								/>) 
							})
					}
				    {
						reOrgAppeal?.additionalOrderMessagesList?.length > 0 &&
						    reOrgAppeal?.additionalOrderMessagesList?.map((value, number) => { return (
								<AdditionalOrderMessage
									isRu={isRu}
									reOrgAppealStatusCode={reOrgAppeal?.status?.code} 
									additionalOrderMessage={value}
									showSignerInfo={reOrgAppeal.appeal.creatorId != user.id}
									key={number}
								/>) 
						    })
					}
					{ reviewResult && reOrgAppeal?.additionalOrderMessagesList?.length == 0 && 
						<AppealResult
							isRu={isRu}
							appealResult={{
								reOrgAppealId : reOrgAppeal.id,
								signerInfo : reOrgAppeal.signerInfo,
								caseNumber : reOrgAppeal.caseNumber,
								status : reOrgAppeal.status,
								endSignDate : reOrgAppeal.endSignDate,
								endSignerInfo : reOrgAppeal.endSignerInfo,
								reviewResult : reviewResult
							}}
							answerFiles={answerFiles}
							showSignerInfo={reOrgAppeal.appeal.creatorId != user.id}
							downloadMethod={downloadAppealAnswerFile}
						/>
					}
					</div>
					{ reOrgAppeal && reOrgAppeal.status.code == "10" &&
					<RecallByRegistratorInfo
						isRu={ isRu }
						reOrgAppealId={ reOrgAppeal.id }
					/>
					}
				</div>
			) : null }
		</>
	)
})

export default AppealInfo
